export default {
  plans: [],
  plansLoading: false,
  subscriptions: [],
  subscriptionsLoading: false,
  subscriberLink: null,
};
